export default __webpack_public_path__ + "static/media/foto14_S_0386.bfae1142.jpg";